export interface ApiError {
    message: string;
    severity: 'error' | 'warning' | 'info';
    shouldLogout?: boolean;
}

function isAuthenticationError(errorMessage: string): boolean {
    const authErrorPatterns = [
        'session token not found',
        'session expired', 
        'invalid session',
        'unauthorized',
        'token expired',
        'authentication failed',
        'please log in again',
        'session invalid',
        'no session token found'
    ];
    const lowerMessage = errorMessage.toLowerCase();
    return authErrorPatterns.some(pattern => lowerMessage.includes(pattern));
}

export function handleApiError(error: any): ApiError {
    let message = 'An unexpected error occurred';
    let severity: 'error' | 'warning' | 'info' = 'error';
    let shouldLogout = false;

    if (error && typeof error === 'object') {
        if (error.isAxiosError) {
            if (error.response) {
                const { status, data } = error.response;

                if (data?.errorMessage && typeof data.errorMessage === 'string') {
                    message = data.errorMessage;
                    if (isAuthenticationError(data.errorMessage)) {
                        shouldLogout = true;
                        severity = 'warning';
                    }
                }
                else if (data?.error && typeof data.error === 'string') {
                    message = data.error;
                    if (isAuthenticationError(data.error)) {
                        shouldLogout = true;
                        severity = 'warning';
                    }
                }
                else if (data?.error && typeof data.error === 'object') {
                    message = data.error.message || JSON.stringify(data.error);
                }
                else {
                    switch (status) {
                        case 400:
                            message = 'Bad request: Invalid input data';
                            break;
                        case 401:
                            message = 'Unauthorized: Please log in again';
                            severity = 'warning';
                            shouldLogout = true; 
                            break;
                        case 403:
                            message = 'Forbidden: You do not have permission';
                            shouldLogout = true;
                            break;
                        case 404:
                            message = 'Resource not found';
                            break;
                        case 500:
                            message = 'Server error: Please try again later';
                            break;
                        default:
                            message = `Request failed with status ${status}`;
                    }
                }
            } else {
                message = 'Network error: Please check your connection';
            }
        }
        else if (error.message) {
            message = error.message;
            if (isAuthenticationError(error.message)) {
                shouldLogout = true;
                severity = 'warning';
            }
        }
        else {
            message = String(error);
            shouldLogout = true;
        }
    } else if (typeof error === 'string') {
        message = error;
        if (isAuthenticationError(error)) {
            shouldLogout = true;
            severity = 'warning';
        }
    }

    return { message, severity, shouldLogout };
}

export function performLogout() {
    localStorage.removeItem('sessionToken');
}